module.exports = __webpack_public_path__ + "img/3.0ad03dee.png";